<div class="register-container">
  <div class="register-card">
    <div class="home-navigation">
      <button mat-button routerLink="/" class="home-link">
        <mat-icon>chevron_left</mat-icon>
        Back to Home
      </button>
    </div>

    <div class="register-header">
      <h1>Create Account</h1>
      <p>Join AI Optima to unlock powerful brand analysis tools</p>
    </div>

    <form [formGroup]="registerForm" (ngSubmit)="register()">
      <div class="form-row">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>First Name</mat-label>
          <input matInput formControlName="first_name" placeholder="Enter first name" />
          <mat-error *ngIf="registerForm.get('first_name')?.touched && registerForm.get('first_name')?.invalid">
            {{ getErrorMessage('first_name') }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="last_name" placeholder="Enter last name" />
          <mat-error *ngIf="registerForm.get('last_name')?.touched && registerForm.get('last_name')?.invalid">
            {{ getErrorMessage('last_name') }}
          </mat-error>
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" type="email" placeholder="Enter email address" />
        <mat-error *ngIf="registerForm.get('email')?.touched && registerForm.get('email')?.invalid">
          {{ getErrorMessage('email') }}
        </mat-error>
      </mat-form-field>

      <!-- <mat-form-field appearance="outline" class="full-width">
        <mat-label>Phone Number</mat-label>
        <input matInput formControlName="phone" placeholder="Enter phone number" />
        <mat-error *ngIf="registerForm.get('phone')?.touched && registerForm.get('phone')?.invalid">
          {{ getErrorMessage('phone') }}
        </mat-error>
      </mat-form-field> -->

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Account Type</mat-label>
        <mat-select formControlName="user_type">
          <mat-option value="Company/brand">Company/brand</mat-option>
          <mat-option value="Agency">Agency</mat-option>
        </mat-select>
        <mat-error *ngIf="registerForm.get('user_type')?.touched && registerForm.get('user_type')?.invalid">
          {{ getErrorMessage('user_type') }}
        </mat-error>
      </mat-form-field>

      <!-- <mat-form-field appearance="outline" class="full-width" *ngIf="showBusinessFields">
        <mat-label>Business Title</mat-label>
        <input matInput formControlName="business_title" placeholder="Enter business title" />
        <mat-error *ngIf="registerForm.get('business_title')?.touched && registerForm.get('business_title')?.invalid">
          {{ getErrorMessage('business_title') }}
        </mat-error>
      </mat-form-field> -->

      <div class="form-row">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Password</mat-label>
          <input matInput formControlName="password" type="password" placeholder="Enter password" />
          <mat-error *ngIf="registerForm.get('password')?.touched && registerForm.get('password')?.invalid">
            {{ getErrorMessage('password') }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Confirm Password</mat-label>
          <input matInput formControlName="confirm_password" type="password" placeholder="Confirm password" />
          <mat-error
            *ngIf="registerForm.get('confirm_password')?.touched && registerForm.get('confirm_password')?.invalid">
            {{ getErrorMessage('confirm_password') }}
          </mat-error>
        </mat-form-field>
      </div>

      <button mat-raised-button color="primary" type="submit" class="full-width register-button"
        [disabled]="registerForm.invalid || isLoading">
        <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
        <span *ngIf="!isLoading">{{ isLoading ? 'Creating Account...' : 'Create Account' }}</span>
      </button>
    </form>

    <div class="login-link">
      <p>Already have an account? <a routerLink="/login">Sign In</a></p>
    </div>
  </div>
</div>
